<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria [disabled]="model.data.invoiceNo"></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <fui-tandem-field>
                                    <wbo-checkbox-edit-control formControlName="invoiceNo" [(ngModel)]="model.data.invoiceNo" (valueChange)="handleInvoiceNo()"></wbo-checkbox-edit-control>
                                    <wbo-text-edit-control formControlName="receiptno" [(ngModel)]="model.data.receiptno" [readonly]="!model.data.invoiceNo"></wbo-text-edit-control>
                                </fui-tandem-field>
                            </fui-column>
                            <fui-column>
                                <wbo-single-select-edit-control [formControlName]="'saletype'"
                                                                [(ngModel)]="model.data.saletype"
                                                                [allowClearSelectionOption]="false">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="'All'"
                                                           label="wbo.detailed-sales-report.option.saleType.all"></wbo-select-option>
                                        <wbo-select-option [value]="'Sale'"
                                                           label="wbo.detailed-sales-report.option.saleType.sale"></wbo-select-option>
                                        <wbo-select-option [value]="'Refund'"
                                                           label="wbo.detailed-sales-report.option.saleType.refund"></wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-entity-group-by-report-criteria [showEmployeeOption]="true"></wbo-entity-group-by-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-entity-sub-group-by-report-criteria></wbo-entity-sub-group-by-report-criteria>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row>
                <wbo-sellable-report-selection></wbo-sellable-report-selection>
            </fui-row>
            <fui-row>
                <wbo-employee-report-selection></wbo-employee-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
